import { builder } from '../../../../../common/js/configs';

export const commonBrand = {
  brand: builder.holder({
    name: builder.string('brand_name', {
      l:'',
      d:'',
      optional: true
    }),
    logo: builder.string('brand_logo', {
      l:'',
      overrideType: 'image',
      d:'',
      optional: true
    })
  })
};
